import { flushSync } from 'react-dom'

type ViewTransitionCapableDocument = Document & {
  startViewTransition?: (updateCallback: () => void) => {
    ready: Promise<void>
    finished: Promise<void>
  }
}

export function scrollWindowToTop(): void {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

/** Crossfade the document when navigating, if the browser supports it. */
export function runViewTransition(update: () => void): void {
  const apply = () => {
    update()
    scrollWindowToTop()
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    apply()
    return
  }

  const doc = document as ViewTransitionCapableDocument
  if (typeof doc.startViewTransition !== 'function') {
    apply()
    return
  }

  const transition = doc.startViewTransition(() => {
    flushSync(apply)
  })

  // The UA restores the old scroll after capture; pin the new page to top.
  void transition.ready.then(scrollWindowToTop)
  void transition.finished.then(scrollWindowToTop)
}
